module.exports = __webpack_public_path__ + "img/partner_icon4.49ec40bf.png";